import SoundWaves from "@assets/animation/sound-waves.gif";
import Close from "@assets/icons/cross.svg";
import Pointer from "@assets/icons/tooltip-pointer.svg";
import { useState } from "react";

export default function PlayerTooltip() {
  const [visible, setVisible] = useState(true);

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="relative z-10 w-[324px] font-primary rounded-md">
      <div
        className="relative bg-neutral-700 rounded-[4px] text-text-inverse text-sm p-3"
        style={{ boxShadow: "1px 2px 2px rgba(0, 0, 0, 0.18)" }}
      >
        <button onClick={handleClose} className="absolute top-2 right-2">
          <img width={24} height={24} src={Close} alt="close" />
        </button>

        <div className="flex items-start gap-2">
          <div>
            <img src={SoundWaves} alt="sound-waves" width={40} height={40} />
          </div>
          <div className="flex flex-col justify-center items-start grow shrink-0 basis-0 font-medium leading-[150%]">
            Dengar berita yang disampaikan
            <br />
            dalam suara wartawan kami yang
            <br />
            dijana oleh kecerdasan buatan
          </div>
        </div>
      </div>

      <div className="px-3">
        <img src={Pointer} width={20} height={8} alt="down" />
      </div>
    </div>
  );
}
